import { appendToBody } from './directives';
import { IValidations } from './interfaces';

export function isEmail(val: string) {
  return val.match(/^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/) !== null;
}

export function getAxiosErrorMessage(ex: any): string | null {
  if (ex && ex.isAxiosError && ex.response && ex.response.data && ex.response.data.message) {
    return ex.response.data.message;
  }
  return null;
}

export function showAxiosErrorMessage(ex: any): void {
  const message = getAxiosErrorMessage(ex);
  if (message !== null) {
    window.$alert.danger('Server Error', message);
  }
}

export function isMinecraftUsername(val: string) {
  if (val.length === 0) return false;
  if (val.length < 3) return false;
  if (val.length > 16) return false;
  if (!(/^\w+$/i.test(val))) return false;
  return true;
}

export function hasUpper(val: string) {
  return val.match(/[A-Z]/) !== null;
}

export function hasLower(val: string) {
  return val.match(/[a-z]/) !== null;
}

export function hasNumber(val: string) {
  return val.match(/\d/) !== null;
}

export function empty(val: string) {
  return val.length === 0;
}

export function isParent(parent: Node, child: Node) {
  let node = child.parentNode;
  while(node !== null) {
    if (node === parent) return true;
    node = node.parentNode;
  }
  return false;
}

export function joinArr<T>(...vals: (Array<T> | undefined)[]) {
  return vals
    .filter(x => x !== undefined)
    .reduce<T[]>((a, i) => a.concat(i as T[]), []);
}

export function truncate(val: string, length: number) {
  return val.length > length ? `${val.substr(0, length - 3)}...` : val;
}

export function wait(milliseconds?: number): Promise<void> {
  return new Promise<void>(resolve => setTimeout(resolve, milliseconds));
}

export function getValidationText<T>(validations: IValidations<T> | null, key: keyof T) {
  return (validations !== null ? validations[key] : null) ?? '';
}

export function copyToClipboard(str: string) {
  const input = document.createElement('input');
  input.value = str;

  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');

  input.remove();
}

// FOUND AT: https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}